<img [src]="icon" alt="icon" class="{{filterClass}}">
